//
//
//
//
//
//
//
//
//

import {NoScroll, Scroll} from '@js/public/animation'
export default {
  name: 'Dialog',
  props: ['message'], // message里包含width和height，代表对话框的宽高
  data () {
    return {
    }
  },
  created () {
  },
  watch: {
    'message'(newVal) {
      this.$refs.sBox.style.width = newVal.width + 'px'
      this.$refs.sBox.style.height = newVal.height + 'px'
      this.$refs.sBox.style.marginLeft = '-' + newVal.width / 2 + 'px'
    }
  },
  mounted () {
    // NoScroll()
    // 设置宽高后居中处理
    console.log(this.message,7766);
    this.$refs.sBox.style.width = this.message.width + 'px'
    this.$refs.sBox.style.height = this.message.height + 'px'
    this.$refs.sBox.style.marginLeft = '-' + this.message.width / 2 + 'px'
  },
  methods: {
    close () {
      this.$emit('close', 'data') // 通知父组件关闭
    }
  },
  destroyed () {
    // Scroll()
  }
}



// WEBPACK FOOTER //
// ./src/components/publicComponents/dialog.vue